<template>
    <div class="bg-white">
        <div>
            <Mainlayout></Mainlayout>
            <CCol sm="12" class="bg-white">
                <CContainer>
                    <CRow>
    
                        <CCol sm="12" style="margin-top: 10%;">
                            <CRow class="mb-3">
                                <CCol sm="1">
                                    <img src="../assets/img/userprofile.png" style="width:50px" />
                                </CCol>
                                <CCol sm="11">
                                    <h3 class="custom-18px-700 text-left font-color-101828">User23</h3>
                                    <h3 class="custom-12px-600 text-left font-color-101828">user@gmail.com</h3>
                                </CCol>
                            </CRow>
    
                            <CButton class="badge-purple bg-928AFD text-white p-2" style="width:80px">
                                All
                            </CButton>
                            <CButton class="badge-purple p-2 font-color-928AFD ml-2">
                                Feedback
                            </CButton>
                        </CCol>
                    </CRow>
                </CContainer>
            </CCol>
            <CCol sm="12" class="bg-white">
                <CContainer>
                    <h3 class="custom-20px-600 text-left font-color-101828 mt-3">Your Activities</h3>
                    <CRow>
                        <CCol sm="3" class="p-1">
                            <CCard class="border-EAECF0 p-2">
                                <img src="../assets/img/car1.png" style="max-width:100%" />
                                <h4 class="custom-18px-600 text-left mt-2">BMW 3 Series</h4>
                                <h5 class="custom-16px-400 font-color-9991FD">BMW</h5>
                                <CRow>
                                    <CCol sm="1">
                                        <img src="../assets/img/star-yellow.png" width="10px" />
                                    </CCol>
                                    <CCol sm="7" class="p-0">
                                        <p class="font-color-98A2B3 custom-14px-400 text-left">4.9 (400 Reviews)</p>
                                    </CCol>
                                    <CCol sm="3" class="p-0">
                                        <CButton class="badge-purple bg-928AFD text-white button-fit">
                                            View
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCard>
                        </CCol>
                        <CCol sm="3" class="p-1">
                            <CCard class="border-EAECF0 p-2">
                                <img src="../assets/img/car2.png" style="max-width:100%" />
                                <h4 class="custom-18px-600 text-left mt-2">BMW 3 Series</h4>
                                <h5 class="custom-16px-400 font-color-9991FD">BMW</h5>
                                <CRow>
                                    <CCol sm="1">
                                        <img src="../assets/img/star-yellow.png" width="10px" />
                                    </CCol>
                                    <CCol sm="7" class="p-0">
                                        <p class="font-color-98A2B3 custom-14px-400 text-left">4.9 (400 Reviews)</p>
                                    </CCol>
                                    <CCol sm="3" class="p-0">
                                        <CButton class="badge-purple bg-928AFD text-white button-fit">
                                            View
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCard>
                        </CCol>
                        <CCol sm="3" class="p-1">
                            <CCard class="border-EAECF0 p-2">
                                <img src="../assets/img/car3.png" style="max-width:100%" />
                                <h4 class="custom-18px-600 text-left mt-2">BMW 3 Series</h4>
                                <h5 class="custom-16px-400 font-color-9991FD">BMW</h5>
                                <CRow>
                                    <CCol sm="1">
                                        <img src="../assets/img/star-yellow.png" width="10px" />
                                    </CCol>
                                    <CCol sm="7" class="p-0">
                                        <p class="font-color-98A2B3 custom-14px-400 text-left">4.9 (400 Reviews)</p>
                                    </CCol>
                                    <CCol sm="3" class="p-0">
                                        <CButton class="badge-purple bg-928AFD text-white button-fit">
                                            View
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCard>
                        </CCol>
                        <CCol sm="3" class="p-1">
                            <CCard class="border-EAECF0 p-2">
                                <img src="../assets/img/car4.png" style="max-width:100%" />
                                <h4 class="custom-18px-600 text-left mt-2">BMW 3 Series</h4>
                                <h5 class="custom-16px-400 font-color-9991FD">BMW</h5>
                                <CRow>
                                    <CCol sm="1">
                                        <img src="../assets/img/star-yellow.png" width="10px" />
                                    </CCol>
                                    <CCol sm="7" class="p-0">
                                        <p class="font-color-98A2B3 custom-14px-400 text-left">4.9 (400 Reviews)</p>
                                    </CCol>
                                    <CCol sm="3" class="p-0">
                                        <CButton class="badge-purple bg-928AFD text-white button-fit">
                                            View
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCard>
                        </CCol>
                        <CCol sm="3" class="p-1">
                            <CCard class="border-EAECF0 p-2">
                                <img src="../assets/img/car5.png" style="max-width:100%" />
                                <h4 class="custom-18px-600 text-left mt-2">BMW 3 Series</h4>
                                <h5 class="custom-16px-400 font-color-9991FD">BMW</h5>
                                <CRow>
                                    <CCol sm="1">
                                        <img src="../assets/img/star-yellow.png" width="10px" />
                                    </CCol>
                                    <CCol sm="7" class="p-0">
                                        <p class="font-color-98A2B3 custom-14px-400 text-left">4.9 (400 Reviews)</p>
                                    </CCol>
                                    <CCol sm="3" class="p-0">
                                        <CButton class="badge-purple bg-928AFD text-white button-fit">
                                            View
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCard>
                        </CCol>
                        <CCol sm="3" class="p-1">
                            <CCard class="border-EAECF0 p-2">
                                <img src="../assets/img/car6.png" style="max-width:100%" />
                                <h4 class="custom-18px-600 text-left mt-2">BMW 3 Series</h4>
                                <h5 class="custom-16px-400 font-color-9991FD">BMW</h5>
                                <CRow>
                                    <CCol sm="1">
                                        <img src="../assets/img/star-yellow.png" width="10px" />
                                    </CCol>
                                    <CCol sm="7" class="p-0">
                                        <p class="font-color-98A2B3 custom-14px-400 text-left">4.9 (400 Reviews)</p>
                                    </CCol>
                                    <CCol sm="3" class="p-0">
                                        <CButton class="badge-purple bg-928AFD text-white button-fit">
                                            View
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCard>
                        </CCol>
    
                    </CRow>
    
                </CContainer>

                <CContainer>
                    <h3 class="custom-20px-600 text-left font-color-101828 mt-3">Your E-Vouchers</h3>
                    <CRow>
                        <CCol sm="4" class="p-1">
                            <CCard class="border-EAECF0 p-2">
                                <img src="../assets/img/pizza1.png" style="max-width:100%" />
                                <h4 class="custom-18px-600 text-left mt-2">Jozonian Pizza</h4>
                                <CRow>
                                    <CCol sm="1">
                                        <img src="../assets/img/calendar-icon.png" width="10px" />
                                    </CCol>
                                    <CCol sm="7" class="p-0">
                                        <p class="font-color-98A2B3 custom-14px-400 text-left">Until 19 Jul, 2025</p>
                                    </CCol>
                                    <CCol sm="3" class="p-0">
                                        <CButton class="badge-purple bg-928AFD text-white button-fit">
                                            Claim
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCard>
                        </CCol>
                        <CCol sm="4" class="p-1">
                            <CCard class="border-EAECF0 p-2">
                                <img src="../assets/img/pizza1.png" style="max-width:100%" />
                                <h4 class="custom-18px-600 text-left mt-2">Jozonian Pizza</h4>
                                <CRow>
                                    <CCol sm="1">
                                        <img src="../assets/img/calendar-icon.png" width="10px" />
                                    </CCol>
                                    <CCol sm="7" class="p-0">
                                        <p class="font-color-98A2B3 custom-14px-400 text-left">Until 19 Jul, 2025</p>
                                    </CCol>
                                    <CCol sm="3" class="p-0">
                                        <CButton class="badge-purple bg-928AFD text-white button-fit">
                                            Claim
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCard>
                        </CCol>
                        <CCol sm="4" class="p-1">
                            <CCard class="border-EAECF0 p-2">
                                <img src="../assets/img/pizza1.png" style="max-width:100%" />
                                <h4 class="custom-18px-600 text-left mt-2">Jozonian Pizza</h4>
                                <CRow>
                                    <CCol sm="1">
                                        <img src="../assets/img/calendar-icon.png" width="10px" />
                                    </CCol>
                                    <CCol sm="7" class="p-0">
                                        <p class="font-color-98A2B3 custom-14px-400 text-left">Until 19 Jul, 2025</p>
                                    </CCol>
                                    <CCol sm="3" class="p-0">
                                        <CButton class="badge-purple bg-928AFD text-white button-fit">
                                            Claim
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCard>
                        </CCol>
                      
    
                    </CRow>
    
                </CContainer>
            </CCol>
        </div>
    
    
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurplerectangle.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";
import Footerweb from "../containers/FooterWeb.vue";
import ToggleCard from '../components/Toggle.vue';
import backgroundUrNoArrow from "../assets/img/bgline.png";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
        Footerweb
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow

        };
    },
    created() {
        AOS.init();

    },
    methods: {
        GoToEvoucher() {
            this.$router.push("SelectionEvoucher");
        }
    }


};
</script>


<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>
